import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./UserSlice";
import imageReducer from "./imageSlice";
import programReducer from "./ProgramSlice";
import QuestionsReducer from "./ProgramQuestions";
import SessionsReducer from "./ProgramSessions";
import CounsellingReducer from "./ProgramCounselling";
import paymentReducer from "./paymentSlice";
import bookingReducer from "./BookingSlice";
import profileReducer from "./ProfileSlice";
import patientReducer from "./PatientSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    image: imageReducer,
    programs: programReducer,
    programSessions: SessionsReducer,
    programQuestions: QuestionsReducer,
    programCounselling: CounsellingReducer,
    payments: paymentReducer,
    booking: bookingReducer,
    profile: profileReducer,
    patient: patientReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
